module.exports = __webpack_public_path__ + "static/media/consultation.7b6109bc.svg";